module.exports = __webpack_public_path__ + "static/img/index-icon1@2x.f99bb27e.png";